import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from 'styled-components'

import Logo from './logo'

const HeaderWrapper = styled.header`
  position: relative;
  z-index: 10;
  background: #201010;
  marginBottom: 1.4rem;
  div {
    margin: 0 auto;
    max-width: 90%;
    padding: 1.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  div * {
    margin-bottom: 0;
  }
  a {
    background-image: none;
  }
`
const StyledLogo = styled(Logo)`
  height: 2rem;
  width: 2rem;
  margin-right: 0.5rem;
`

const StyledLink = styled(Link)`
  color: white;
  text-decoration: none;
`

const StyledListLink = styled.li`
  display: inline-block;
  margin-right: 1rem;
  margin-bottom: 0.25rem;
  flex-basis: 15%; 
  text-align: right;

  @media (max-width: 650px) {
    flex-basis: 30%; 
  }
  @media (max-width: 400px) {
    flex-basis: 100%; 
  }
`

const ListLink = props => (
  <StyledListLink>
    <StyledLink to={props.to}>{props.children}</StyledLink>
  </StyledListLink>
)

const Header = ({ siteTitle }) => (
  <HeaderWrapper>
    <div>
      <h1 style={{
        margin: 0,
        flex: '0 0 auto',
      }}>
        <StyledLink to="/">
          <StyledLogo fillColor="#fff"/>
          {siteTitle}
        </StyledLink>
      </h1>
      <ul style={{
        listStyle: `none`,
        float: `right`,
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap'
      }}>
        <ListLink to="/">Główna</ListLink>
        <ListLink to="/about/">O&nbsp;mnie</ListLink>
        <ListLink to="/projects/">Projekty</ListLink>
        <ListLink to="/contact/">Kontakt</ListLink>
      </ul>
    </div>
  </HeaderWrapper>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
